import moment from "moment";
import React, { useEffect, useState, useRef, ComponentState } from "react";
import DatePickerKendoRct from "src/control-components/date-picker/date-picker";
import { filterBy } from "@progress/kendo-data-query";
import { useDispatch, useSelector } from "react-redux";
import {
  getCAPServices,
  getCapServiceReport,
  getClientList,
  getStaffList,
  saveButtonPressed,
  setClientReportFilters,
} from "src/redux/actions";
import DropDownKendoRct from "src/control-components/drop-down/drop-down";
import { NotificationManager } from "react-notifications";
import {
  CapNoteReportData,
  GetCapReportsModel,
} from "src/dataModels/reportsModel";
import MultiSelectDropDown from "src/control-components/multi-select-drop-down/multi-select-drop-down";
import { renderToItem } from "./report-filtrs";
import calender from "../../assets/images/calendar-03.png";

const durationOptions = [
  { name: "Current week", value: 1 },
  { name: "Last week", value: 2 },
  { name: "Current month", value: 3 },
  { name: "Last month", value: 4 },
  { name: "Last 60 days", value: 5 },
  { name: "Last 90 days", value: 6 },
];

function getDateRange(option) {
  const today = new Date();
  let startDate, endDate;
  switch (option) {
    case 1:
      startDate = new Date(today.setDate(today.getDate() - today.getDay()));
      endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + 6);
      break;

    case 2:
      startDate = new Date(today.setDate(today.getDate() - today.getDay() - 7));
      endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + 6);
      break;

    case 3:
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      break;

    case 4:
      startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      endDate = new Date(today.getFullYear(), today.getMonth(), 0);
      break;

    case 5:
      startDate = new Date();
      startDate.setDate(today.getDate() - 60);
      endDate = today;
      break;

    case 6:
      startDate = new Date();
      startDate.setDate(today.getDate() - 90);
      endDate = today;
      break;

    default:
      throw new Error("Invalid option selected");
  }

  return { startDate, endDate };
}

function isDateRangeValid(startDate, endDate) {
  const date1 = moment(startDate);
  const date2 = moment(endDate);
  const diffInDays = date2.diff(date1, "days");
  return diffInDays < 91;
}

export interface CapMappedDataByWeek {
  weekStart: any;
  weekEnd: any;
  data: CapNoteReportData[];
}

export interface CapReportFilterProps {
  setStartDate(date): void;
  setEndDate(date): void;
  exportClick(): void;
  clearClick(): void;
}

function CapReportFilters(props: CapReportFilterProps) {
  const state: ComponentState = useSelector((states) => {
    return states;
  });
  const [filter, setFilter] = useState<any>();
  const { clientList, staffsList } = state["DocumentReducer"];
  const [isDataLoadStart, setDataLoadStart] = useState(false);

  const [serviceStartDate, setServiceStartDate] = useState<any>();
  const [serviceEndDate, setServiceEndDate] = useState<any>();
  const [runClicked, setRunClicked] = useState(false);

  const capServices = useSelector(
    (state: ComponentState) => state.ClientReducer.capServices
  );

  const handleHoldDate = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    props.clearClick();
    setSelectedDurationMethod(1);
    if (name === "serviceStartDate") {
      if (serviceEndDate && value <= serviceEndDate) {
        setServiceStartDate(value);
      } else if (!serviceEndDate) {
        setServiceStartDate(value);
      }
    } else {
      if (serviceStartDate && value >= serviceStartDate) {
        setServiceEndDate(value);
      } else if (!serviceStartDate) {
        setServiceEndDate(value);
      }
    }
  };

  const handleGenerateReportClick = () => {
    setRunClicked(true);
    if (
      !(selectedDuration || !selectedDuration?.value) &&
      !(serviceStartDate && serviceEndDate)
    ) {
      return;
    } else if (!selectedClient) {
      return;
    } else if (!selectedService) {
      return;
    } else {
      const startData =
        selectedDurationMethod === 0
          ? getDateRange(selectedDuration.value).startDate
          : serviceStartDate;
      const endDate =
        selectedDurationMethod === 0
          ? getDateRange(selectedDuration.value).endDate
          : serviceEndDate;
      if (!isDateRangeValid(startData, endDate)) {
        NotificationManager.error(
          "Please select date range for 90 days or less"
        );
      } else {
        const reportReqModel: GetCapReportsModel = {
          clientId: selectedClient.id,
          endDate: moment(endDate).format("YYYY-MM-DD"),
          startDate: moment(startData).format("YYYY-MM-DD"),
          staffIds:
            selectedStaff && selectedStaff.length > 0
              ? selectedStaff?.map((staff) => staff.id)
              : [],
          capServiceId: selectedService.id,
        };
        props.setStartDate(startData);
        props.setEndDate(endDate);
        props.clearClick();
        dispatch(getCapServiceReport(reportReqModel));
      }
    }
  };

  useEffect(() => {
    if (!isDataLoadStart) {
      callSiteListApiData();
      setDataLoadStart(true);
    }
  }, [isDataLoadStart]);

  const dispatch = useDispatch();

  const callSiteListApiData = async () => {
    dispatch(getClientList(true));
    dispatch(getStaffList(true));
    dispatch(getCAPServices());
  };

  function clearAllFilter() {
    const reportFilterParams = {
      isActive: true,
      sites: [],
      serviceDate: moment(new Date()).format("M/D/yyyy"),
    };
    setServiceEndDate(undefined);
    setServiceStartDate(undefined);
    setSelectedClient(undefined);
    setSelectedService(undefined);
    setSelectedStaff([]);
    setSelectedDuration(undefined);
    dispatch(setClientReportFilters(reportFilterParams));
    dispatch(saveButtonPressed(true));
    props.clearClick();
  }

  const [selectedDuration, setSelectedDuration] = useState<any>();
  const [selectedDurationMethod, setSelectedDurationMethod] = useState(0);
  const [selectedClient, setSelectedClient] = useState<any>();
  const [selectedStaff, setSelectedStaff] = useState<any>([]);
  const [selectedService, setSelectedService] = useState<any>();

  return (
    <>
      <div className="capNoteWrapper py-md-2 py-1">
        <div className="d-flex  flex-wrap">
          <div className="mb-2 col-lg-3 col-md-6 col-12">
            <DropDownKendoRct
              data={durationOptions}
              value={selectedDuration ? selectedDuration : null}
              label="Duration"
              onChange={(event) => {
                setSelectedDuration(event.target.value);
                setSelectedDurationMethod(0);
                setServiceStartDate(undefined);
                setServiceEndDate(undefined);
                props.clearClick();
              }}
              error={
                runClicked &&
                !selectedDuration &&
                (!serviceStartDate || !serviceEndDate) &&
                "Required *"
              }
              textField="name"
              dataItemKey={"value"}
            />
          </div>{" "}
          <span className="optionText">-- OR --</span>
          <div className=" row m-0 blue_theme">
            <div className="col-md-6 col-12 position-relative ">
              <DatePickerKendoRct
                validityStyles={false}
                value={serviceStartDate && new Date(serviceStartDate)}
                onChange={handleHoldDate}
                name="serviceStartDate"
                label="From"
                placeholder="M/D/YYYY"
                max={serviceEndDate ? new Date(serviceEndDate) : new Date()}
              />
              <img
                src={calender}
                alt=""
                className="blueThemeIcons "
              />
            </div>
            <div className="col-md-6 col-12 position-relative ">
              <DatePickerKendoRct
                validityStyles={false}
                value={serviceEndDate && new Date(serviceEndDate)}
                onChange={handleHoldDate}
                max={new Date()}
                name="serviceEndDate"
                label="To"
                placeholder="M/D/YYYY"
                min={serviceStartDate && new Date(serviceStartDate)}
              />
              <img
                src={calender}
                className="blueThemeIcons "
              />
            </div>
          </div>
        </div>
        <div className="row m-0">
          <div className="mb-2 col-lg-3 col-md-6 col-12">
            {clientList && (
              <div>
                <DropDownKendoRct
                  data={filterBy(
                    clientList,
                    filter && filter.clientList ? filter?.clientList : []
                  )}
                  loading={!clientList}
                  textField="name"
                  value={selectedClient ? selectedClient : null}
                  onChange={(event) => {
                    props.clearClick();
                    setSelectedClient(event.target.value);
                  }}
                  autoClose={false}
                  dataItemKey={"id"}
                  error={runClicked && !selectedClient && "Required *"}
                  label="Client"
                />
              </div>
            )}
          </div>
          <div className="mb-2 col-lg-3 col-md-6 col-12">
            {capServices && (
              <DropDownKendoRct
                data={filterBy(capServices, filter ? filter?.capServices : [])}
                loading={!capServices}
                textField="name"
                value={selectedService ? selectedService : null}
                onChange={(event) => {
                  props.clearClick();
                  setSelectedService(event.target.value);
                }}
                autoClose={false}
                dataItemKey={"id"}
                error={runClicked && !selectedService && "Required *"}
                label="CAP Service"
              />
            )}
          </div>

          <div className="mb-2 col-lg-3 col-md-6 col-12 lableMarginZero">
            {staffsList && (
              <MultiSelectDropDown
                data={filterBy(staffsList, filter ? filter.staffsList : [])}
                textField="name"
                name="staff"
                value={selectedStaff}
                onChange={(event) => {
                  props.clearClick();
                  setSelectedStaff(event.target.value);
                }}
                autoClose={false}
                dataItemKey={"id"}
                itemRender={renderToItem}
                label="Staff"
                error={runClicked && !selectedStaff && "Required *"}
              />
            )}
          </div>
          <div className="col-lg-3 col-sm-12 d-flex justify-content-start align-items-center clear-add-filter gap-3 mt-3">
            <button
              className="submitButon f-14 d-flex align-items-center my-2"
              onClick={handleGenerateReportClick}
            >
              Run Report
            </button>
            <p className="mb-0" onClick={clearAllFilter}>
              Clear Filter
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
export default CapReportFilters;
